// src/data/projectContent.js

const tokenLegalAdviceProject = [
    {
      title: "Aspectos Legales en la Tokenización: Recomendaciones y Buenas Prácticas",
      value: `
  ## Legalidad antes que Código
  
  Antes de escribir cualquier línea de código, es fundamental comprender lo siguiente:
  
  > Un documento debe ser legal **y estar firmado en el mundo real** antes de integrarse en un contrato inteligente.
  
  Esto no se trata únicamente de programación — **es indispensable contar con la asesoría de un abogado** para evitar consecuencias legales futuras.
  
  ---
  
  ## Facilitando el Proceso
  
  Para simplificar este paso, el proyecto proporciona:
  
  - Un **modelo de contrato legal** editable.
  - Campos predefinidos que pueden ser completados con la información correspondiente al caso específico.
  
  ---
  
  ## Advertencia Importante
  
  Es responsabilidad del usuario:
  
  - Verificar que el documento esté correctamente redactado por un profesional del derecho.
  - Asegurarse de que esté **firmado y legalmente registrado** conforme a la legislación aplicable.
  
  ---
  
  ## ¿Qué sigue?
  
  Una vez firmado y validado el documento legal, el proyecto enseña a:
  
  - Integrarlo dentro del **contrato inteligente**.
  - **Vincular los valores y derechos** que representará el token.
  
  ---
  
  ## Recomendación Profesional
  
  Como parte del desarrollo de este proyecto, se ha seguido una máxima legal esencial:
  
  > "Siempre se deben leer los documentos legales detenidamente. Están redactados en el idioma del firmante. Si algo no se entiende, es obligación del responsable buscar respuestas claras."
  
  Por ello, se enfatiza:
  
  **Leer, comprender, preguntar e investigar.**
  
  Dominar los aspectos legales distingue a quienes trabajan profesionalmente en el ámbito de la tokenización.
  
  ---
  

      `,
    },
  ];
  
  export default tokenLegalAdviceProject;
  